import { differenceInMonths } from "date-fns";
import type { InvestmentProperty } from "@aus-property/core";

const toYearsElapsed = (purchaseDateIso: string, now = new Date()): number => {
  const purchase = new Date(purchaseDateIso);
  if (Number.isNaN(purchase.getTime())) return 0;
  const months = differenceInMonths(now, purchase);
  return Math.max(0, months / 12);
};

const compound = (principal: number, annualRatePercent: number, years: number): number => {
  if (!Number.isFinite(principal) || principal <= 0) return 0;
  const r = annualRatePercent / 100;
  if (!Number.isFinite(r) || r <= 0) return principal;
  return principal * Math.pow(1 + r, years);
};

export const estimateValueToday = (
  property: InvestmentProperty,
  now = new Date()
): number => {
  const years = toYearsElapsed(property.purchase.purchaseDate, now);
  return compound(property.purchase.price, property.growth.capitalGrowthRate, years);
};

export const estimateWeeklyRentToday = (
  property: InvestmentProperty,
  now = new Date()
): number => {
  const years = toYearsElapsed(property.purchase.purchaseDate, now);
  return compound(property.income.weeklyRent, property.growth.rentGrowthRate, years);
};

export const estimateGrossYieldToday = (
  property: InvestmentProperty,
  now = new Date()
): number => {
  const value = estimateValueToday(property, now);
  if (value <= 0) return 0;
  const weekly = estimateWeeklyRentToday(property, now);
  const annual = weekly * 52;
  return annual / value;
};

